import React from 'react';
import PageHeader from '../components/PageHeader';
import Services from '../components/Services';
import Process from '../components/Process';
import FAQ from '../components/FAQ';
import AuditPromo from '../components/AuditPromo';
import CtaBand from '../components/CtaBand';
import usePageMeta from '../utils/usePageMeta';

const ServicesPage = () => {
  usePageMeta('Digital Services for Schools & Educational Institutes', 'Websites, apps, school ERP, digital presence, digital marketing, digital classrooms, educational content, career counselling, video and design for institutes.');

  return (
    <>
      <PageHeader
        eyebrow="Services"
        title="Every digital service your institute needs."
        subtitle="From your website and ERP to marketing, smart classrooms, content and career counselling. Pick one service or let us handle it all."
      />
      <Services showHead={false} />
      <Process />
      <AuditPromo />
      <FAQ />
      <CtaBand />
    </>
  );
};

export default ServicesPage;
